const DATUM_ZEIT = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const DATUM = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const UHRZEIT = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' });

function formatiere(iso: string, formatierer: Intl.DateTimeFormat): string {
  const zeitpunkt = Date.parse(iso);
  // Ein unlesbarer Zeitstempel wird durchgereicht statt zu "Invalid Date": Der Rohwert
  // sagt einem Menschen mehr und verdeckt keinen Datenfehler.
  return Number.isNaN(zeitpunkt) ? iso : formatierer.format(zeitpunkt);
}

export function alsDatumZeit(iso: string): string {
  return formatiere(iso, DATUM_ZEIT);
}

export function alsDatum(iso: string): string {
  return formatiere(iso, DATUM);
}

export function alsUhrzeit(iso: string): string {
  return formatiere(iso, UHRZEIT);
}

/**
 * Wie lange steht dieser Zeitpunkt schon zurueck, in Worten.
 *
 * Beantwortet die Frage, die ein Nutzer vor einem laufenden Schritt wirklich hat: "haengt
 * das?" Die Haenger-Warnung greift erst nach 45 Minuten -- bis dahin stand vorher nur der
 * Statusname da, und sechs Minuten Finalisierung fuehlen sich ohne Zeitangabe endlos an
 * (Befund der Live-Abnahme vom 2026-09-10).
 *
 * Leerer String statt einer Schaetzung, wenn der Zeitstempel unlesbar ist oder in der
 * Zukunft liegt: Browser- und n8n-Uhr koennen auseinanderlaufen, und "seit -3 Minuten"
 * waere schlechter als gar nichts.
 */
export function alsDauerSeit(iso: string, jetzt: Date): string {
  const zeitpunkt = Date.parse(iso);
  if (Number.isNaN(zeitpunkt)) return '';

  const minutenGesamt = Math.floor((jetzt.getTime() - zeitpunkt) / 60_000);
  if (minutenGesamt < 0) return '';
  if (minutenGesamt === 0) return 'seit weniger als einer Minute';

  const stunden = Math.floor(minutenGesamt / 60);
  const minuten = minutenGesamt % 60;

  if (stunden === 0) return `seit ${minuten} ${minuten === 1 ? 'Minute' : 'Minuten'}`;

  const stundenTeil = `${stunden} ${stunden === 1 ? 'Stunde' : 'Stunden'}`;
  if (minuten === 0) return `seit ${stundenTeil}`;
  return `seit ${stundenTeil} ${minuten} ${minuten === 1 ? 'Minute' : 'Minuten'}`;
}
